// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { cmip7AssessmentFastTrackAftGetAftDiagnostic, cmip7AssessmentFastTrackAftListAftDiagnostics, datasetsExecutions, datasetsGet, datasetsList, diagnosticsFacets, diagnosticsGet, diagnosticsList, diagnosticsListExecutionGroups, diagnosticsListExecutions, diagnosticsListMetricValues, executionsExecution, executionsExecutionArchive, executionsExecutionDatasets, executionsExecutionLogs, executionsGet, executionsGetExecutionStatistics, executionsListMetricValues, executionsListRecentExecutionGroups, executionsMetricBundle, explorerGetCollection, explorerGetTheme, explorerListCollections, explorerListThemes, modelsEnsemble, modelsGet, modelsList, type Options, resultsGetResult, utilsAbout, utilsHealthCheck } from '../sdk.gen';
import type { Cmip7AssessmentFastTrackAftGetAftDiagnosticData, Cmip7AssessmentFastTrackAftGetAftDiagnosticError, Cmip7AssessmentFastTrackAftGetAftDiagnosticResponse, Cmip7AssessmentFastTrackAftListAftDiagnosticsData, Cmip7AssessmentFastTrackAftListAftDiagnosticsResponse, DatasetsExecutionsData, DatasetsExecutionsError, DatasetsExecutionsResponse, DatasetsGetData, DatasetsGetError, DatasetsGetResponse, DatasetsListData, DatasetsListError, DatasetsListResponse, DiagnosticsFacetsData, DiagnosticsFacetsResponse, DiagnosticsGetData, DiagnosticsGetError, DiagnosticsGetResponse, DiagnosticsListData, DiagnosticsListError, DiagnosticsListExecutionGroupsData, DiagnosticsListExecutionGroupsError, DiagnosticsListExecutionGroupsResponse, DiagnosticsListExecutionsData, DiagnosticsListExecutionsError, DiagnosticsListExecutionsResponse, DiagnosticsListMetricValuesData, DiagnosticsListMetricValuesError, DiagnosticsListMetricValuesResponse, DiagnosticsListResponse, ExecutionsExecutionArchiveData, ExecutionsExecutionArchiveError, ExecutionsExecutionData, ExecutionsExecutionDatasetsData, ExecutionsExecutionDatasetsError, ExecutionsExecutionDatasetsResponse, ExecutionsExecutionError, ExecutionsExecutionLogsData, ExecutionsExecutionLogsError, ExecutionsExecutionResponse, ExecutionsGetData, ExecutionsGetError, ExecutionsGetExecutionStatisticsData, ExecutionsGetExecutionStatisticsResponse, ExecutionsGetResponse, ExecutionsListMetricValuesData, ExecutionsListMetricValuesError, ExecutionsListMetricValuesResponse, ExecutionsListRecentExecutionGroupsData, ExecutionsListRecentExecutionGroupsError, ExecutionsListRecentExecutionGroupsResponse, ExecutionsMetricBundleData, ExecutionsMetricBundleError, ExecutionsMetricBundleResponse, ExplorerGetCollectionData, ExplorerGetCollectionError, ExplorerGetCollectionResponse, ExplorerGetThemeData, ExplorerGetThemeError, ExplorerGetThemeResponse, ExplorerListCollectionsData, ExplorerListCollectionsResponse, ExplorerListThemesData, ExplorerListThemesResponse, ModelsEnsembleData, ModelsEnsembleError, ModelsEnsembleResponse, ModelsGetData, ModelsGetError, ModelsGetResponse, ModelsListData, ModelsListError, ModelsListResponse, ResultsGetResultData, ResultsGetResultError, UtilsAboutData, UtilsAboutResponse, UtilsHealthCheckData, UtilsHealthCheckResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const cmip7AssessmentFastTrackAftListAftDiagnosticsQueryKey = (options?: Options<Cmip7AssessmentFastTrackAftListAftDiagnosticsData>) => createQueryKey('cmip7AssessmentFastTrackAftListAftDiagnostics', options);

/**
 * List Aft Diagnostics
 *
 * Get all AFT diagnostics.
 */
export const cmip7AssessmentFastTrackAftListAftDiagnosticsOptions = (options?: Options<Cmip7AssessmentFastTrackAftListAftDiagnosticsData>) => queryOptions<Cmip7AssessmentFastTrackAftListAftDiagnosticsResponse, DefaultError, Cmip7AssessmentFastTrackAftListAftDiagnosticsResponse, ReturnType<typeof cmip7AssessmentFastTrackAftListAftDiagnosticsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await cmip7AssessmentFastTrackAftListAftDiagnostics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: cmip7AssessmentFastTrackAftListAftDiagnosticsQueryKey(options)
});

export const cmip7AssessmentFastTrackAftGetAftDiagnosticQueryKey = (options: Options<Cmip7AssessmentFastTrackAftGetAftDiagnosticData>) => createQueryKey('cmip7AssessmentFastTrackAftGetAftDiagnostic', options);

/**
 * Get Aft Diagnostic
 *
 * Get detailed AFT diagnostic by ID.
 */
export const cmip7AssessmentFastTrackAftGetAftDiagnosticOptions = (options: Options<Cmip7AssessmentFastTrackAftGetAftDiagnosticData>) => queryOptions<Cmip7AssessmentFastTrackAftGetAftDiagnosticResponse, Cmip7AssessmentFastTrackAftGetAftDiagnosticError, Cmip7AssessmentFastTrackAftGetAftDiagnosticResponse, ReturnType<typeof cmip7AssessmentFastTrackAftGetAftDiagnosticQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await cmip7AssessmentFastTrackAftGetAftDiagnostic({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: cmip7AssessmentFastTrackAftGetAftDiagnosticQueryKey(options)
});

export const datasetsListQueryKey = (options?: Options<DatasetsListData>) => createQueryKey('datasetsList', options);

/**
 * List
 *
 * Paginated list of currently ingested datasets
 *
 * Only the latest version of each dataset is returned.
 */
export const datasetsListOptions = (options?: Options<DatasetsListData>) => queryOptions<DatasetsListResponse, DatasetsListError, DatasetsListResponse, ReturnType<typeof datasetsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await datasetsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: datasetsListQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const datasetsListInfiniteQueryKey = (options?: Options<DatasetsListData>): QueryKey<Options<DatasetsListData>> => createQueryKey('datasetsList', options, true);

/**
 * List
 *
 * Paginated list of currently ingested datasets
 *
 * Only the latest version of each dataset is returned.
 */
export const datasetsListInfiniteOptions = (options?: Options<DatasetsListData>) => {
    const opts = infiniteQueryOptions<DatasetsListResponse, DatasetsListError, InfiniteData<DatasetsListResponse>, QueryKey<Options<DatasetsListData>>, number | Pick<QueryKey<Options<DatasetsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<DatasetsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await datasetsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: datasetsListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const datasetsGetQueryKey = (options: Options<DatasetsGetData>) => createQueryKey('datasetsGet', options);

/**
 * Get
 *
 * Get a single dataset by slug
 *
 * When several versions share a slug, the latest is returned.
 */
export const datasetsGetOptions = (options: Options<DatasetsGetData>) => queryOptions<DatasetsGetResponse, DatasetsGetError, DatasetsGetResponse, ReturnType<typeof datasetsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await datasetsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: datasetsGetQueryKey(options)
});

export const datasetsExecutionsQueryKey = (options: Options<DatasetsExecutionsData>) => createQueryKey('datasetsExecutions', options);

/**
 * Executions
 *
 * List the currently registered diagnostics
 */
export const datasetsExecutionsOptions = (options: Options<DatasetsExecutionsData>) => queryOptions<DatasetsExecutionsResponse, DatasetsExecutionsError, DatasetsExecutionsResponse, ReturnType<typeof datasetsExecutionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await datasetsExecutions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: datasetsExecutionsQueryKey(options)
});

export const datasetsExecutionsInfiniteQueryKey = (options: Options<DatasetsExecutionsData>): QueryKey<Options<DatasetsExecutionsData>> => createQueryKey('datasetsExecutions', options, true);

/**
 * Executions
 *
 * List the currently registered diagnostics
 */
export const datasetsExecutionsInfiniteOptions = (options: Options<DatasetsExecutionsData>) => {
    const opts = infiniteQueryOptions<DatasetsExecutionsResponse, DatasetsExecutionsError, InfiniteData<DatasetsExecutionsResponse>, QueryKey<Options<DatasetsExecutionsData>>, number | Pick<QueryKey<Options<DatasetsExecutionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<DatasetsExecutionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await datasetsExecutions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: datasetsExecutionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const diagnosticsListQueryKey = (options?: Options<DiagnosticsListData>) => createQueryKey('diagnosticsList', options);

/**
 * List
 *
 * List the currently registered diagnostics
 *
 * Pass `mip_era` to count only the execution groups that ran against that era.
 */
export const diagnosticsListOptions = (options?: Options<DiagnosticsListData>) => queryOptions<DiagnosticsListResponse, DiagnosticsListError, DiagnosticsListResponse, ReturnType<typeof diagnosticsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await diagnosticsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: diagnosticsListQueryKey(options)
});

export const diagnosticsFacetsQueryKey = (options?: Options<DiagnosticsFacetsData>) => createQueryKey('diagnosticsFacets', options);

/**
 * Facets
 *
 * Query the unique dimensions and metrics for all diagnostics (both scalar and series)
 */
export const diagnosticsFacetsOptions = (options?: Options<DiagnosticsFacetsData>) => queryOptions<DiagnosticsFacetsResponse, DefaultError, DiagnosticsFacetsResponse, ReturnType<typeof diagnosticsFacetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await diagnosticsFacets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: diagnosticsFacetsQueryKey(options)
});

export const diagnosticsGetQueryKey = (options: Options<DiagnosticsGetData>) => createQueryKey('diagnosticsGet', options);

/**
 * Get
 *
 * Fetch a result using the slug
 */
export const diagnosticsGetOptions = (options: Options<DiagnosticsGetData>) => queryOptions<DiagnosticsGetResponse, DiagnosticsGetError, DiagnosticsGetResponse, ReturnType<typeof diagnosticsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await diagnosticsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: diagnosticsGetQueryKey(options)
});

export const diagnosticsListExecutionGroupsQueryKey = (options: Options<DiagnosticsListExecutionGroupsData>) => createQueryKey('diagnosticsListExecutionGroups', options);

/**
 * List Execution Groups
 *
 * Fetch execution groups for a diagnostic.
 *
 * Pass `mip_era` to keep only the groups that ran against that era.
 */
export const diagnosticsListExecutionGroupsOptions = (options: Options<DiagnosticsListExecutionGroupsData>) => queryOptions<DiagnosticsListExecutionGroupsResponse, DiagnosticsListExecutionGroupsError, DiagnosticsListExecutionGroupsResponse, ReturnType<typeof diagnosticsListExecutionGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await diagnosticsListExecutionGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: diagnosticsListExecutionGroupsQueryKey(options)
});

export const diagnosticsListExecutionsQueryKey = (options: Options<DiagnosticsListExecutionsData>) => createQueryKey('diagnosticsListExecutions', options);

/**
 * List Executions
 *
 * Fetch executions for a specific diagnostic, with arbitrary filters on the dataset.
 *
 * e.g. `?source_id=MIROC6&experiment_id=ssp585`. Pass `mip_era` to restrict to one era.
 */
export const diagnosticsListExecutionsOptions = (options: Options<DiagnosticsListExecutionsData>) => queryOptions<DiagnosticsListExecutionsResponse, DiagnosticsListExecutionsError, DiagnosticsListExecutionsResponse, ReturnType<typeof diagnosticsListExecutionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await diagnosticsListExecutions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: diagnosticsListExecutionsQueryKey(options)
});

export const diagnosticsListMetricValuesQueryKey = (options: Options<DiagnosticsListMetricValuesData>) => createQueryKey('diagnosticsListMetricValues', options);

/**
 * List Metric Values
 *
 * Get all the diagnostic values for a given diagnostic (both scalar and series)
 *
 * - `value_type`: Type of metric values - 'scalar', 'series', or 'all' (required)
 * - `format`: Return format - 'json' (default) or 'csv'
 * - `offset`: Number of items to skip (default 0)
 * - `limit`: Maximum number of items to return (default 50, max 500)
 * - `mip_era`: Restrict to the executions of one era, so outlier detection and pagination
 * see only the values the caller is charting
 */
export const diagnosticsListMetricValuesOptions = (options: Options<DiagnosticsListMetricValuesData>) => queryOptions<DiagnosticsListMetricValuesResponse, DiagnosticsListMetricValuesError, DiagnosticsListMetricValuesResponse, ReturnType<typeof diagnosticsListMetricValuesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await diagnosticsListMetricValues({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: diagnosticsListMetricValuesQueryKey(options)
});

export const diagnosticsListMetricValuesInfiniteQueryKey = (options: Options<DiagnosticsListMetricValuesData>): QueryKey<Options<DiagnosticsListMetricValuesData>> => createQueryKey('diagnosticsListMetricValues', options, true);

/**
 * List Metric Values
 *
 * Get all the diagnostic values for a given diagnostic (both scalar and series)
 *
 * - `value_type`: Type of metric values - 'scalar', 'series', or 'all' (required)
 * - `format`: Return format - 'json' (default) or 'csv'
 * - `offset`: Number of items to skip (default 0)
 * - `limit`: Maximum number of items to return (default 50, max 500)
 * - `mip_era`: Restrict to the executions of one era, so outlier detection and pagination
 * see only the values the caller is charting
 */
export const diagnosticsListMetricValuesInfiniteOptions = (options: Options<DiagnosticsListMetricValuesData>) => {
    const opts = infiniteQueryOptions<DiagnosticsListMetricValuesResponse, DiagnosticsListMetricValuesError, InfiniteData<DiagnosticsListMetricValuesResponse>, QueryKey<Options<DiagnosticsListMetricValuesData>>, number | Pick<QueryKey<Options<DiagnosticsListMetricValuesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<DiagnosticsListMetricValuesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await diagnosticsListMetricValues({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: diagnosticsListMetricValuesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const executionsGetExecutionStatisticsQueryKey = (options?: Options<ExecutionsGetExecutionStatisticsData>) => createQueryKey('executionsGetExecutionStatistics', options);

/**
 * Get Execution Statistics
 *
 * Get execution statistics for the dashboard.
 *
 * Execution groups are counted at the promoted version of each diagnostic,
 * and classified by the outcome of their latest execution.
 */
export const executionsGetExecutionStatisticsOptions = (options?: Options<ExecutionsGetExecutionStatisticsData>) => queryOptions<ExecutionsGetExecutionStatisticsResponse, DefaultError, ExecutionsGetExecutionStatisticsResponse, ReturnType<typeof executionsGetExecutionStatisticsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await executionsGetExecutionStatistics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: executionsGetExecutionStatisticsQueryKey(options)
});

export const executionsListRecentExecutionGroupsQueryKey = (options?: Options<ExecutionsListRecentExecutionGroupsData>) => createQueryKey('executionsListRecentExecutionGroups', options);

/**
 * List Recent Execution Groups
 *
 * List the most recent execution groups
 *
 * Only groups at the promoted version of their diagnostic are returned.
 *
 * Supports filtering by:
 * - diagnostic_name_contains (case-insensitive substring of the diagnostic slug)
 * - provider_name_contains (case-insensitive substring of the provider slug)
 * - dirty
 * - successful (filters by latest execution success)
 * - source_id (filters groups that include an execution whose datasets
 * include a CMIP6 or CMIP7 dataset with this source_id)
 * - mip_era (restricts the above to a single era, CMIP6 or CMIP7)
 */
export const executionsListRecentExecutionGroupsOptions = (options?: Options<ExecutionsListRecentExecutionGroupsData>) => queryOptions<ExecutionsListRecentExecutionGroupsResponse, ExecutionsListRecentExecutionGroupsError, ExecutionsListRecentExecutionGroupsResponse, ReturnType<typeof executionsListRecentExecutionGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await executionsListRecentExecutionGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: executionsListRecentExecutionGroupsQueryKey(options)
});

export const executionsListRecentExecutionGroupsInfiniteQueryKey = (options?: Options<ExecutionsListRecentExecutionGroupsData>): QueryKey<Options<ExecutionsListRecentExecutionGroupsData>> => createQueryKey('executionsListRecentExecutionGroups', options, true);

/**
 * List Recent Execution Groups
 *
 * List the most recent execution groups
 *
 * Only groups at the promoted version of their diagnostic are returned.
 *
 * Supports filtering by:
 * - diagnostic_name_contains (case-insensitive substring of the diagnostic slug)
 * - provider_name_contains (case-insensitive substring of the provider slug)
 * - dirty
 * - successful (filters by latest execution success)
 * - source_id (filters groups that include an execution whose datasets
 * include a CMIP6 or CMIP7 dataset with this source_id)
 * - mip_era (restricts the above to a single era, CMIP6 or CMIP7)
 */
export const executionsListRecentExecutionGroupsInfiniteOptions = (options?: Options<ExecutionsListRecentExecutionGroupsData>) => {
    const opts = infiniteQueryOptions<ExecutionsListRecentExecutionGroupsResponse, ExecutionsListRecentExecutionGroupsError, InfiniteData<ExecutionsListRecentExecutionGroupsResponse>, QueryKey<Options<ExecutionsListRecentExecutionGroupsData>>, number | Pick<QueryKey<Options<ExecutionsListRecentExecutionGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ExecutionsListRecentExecutionGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await executionsListRecentExecutionGroups({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: executionsListRecentExecutionGroupsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const executionsGetQueryKey = (options: Options<ExecutionsGetData>) => createQueryKey('executionsGet', options);

/**
 * Get
 *
 * Inspect a specific execution
 */
export const executionsGetOptions = (options: Options<ExecutionsGetData>) => queryOptions<ExecutionsGetResponse, ExecutionsGetError, ExecutionsGetResponse, ReturnType<typeof executionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await executionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: executionsGetQueryKey(options)
});

export const executionsExecutionQueryKey = (options: Options<ExecutionsExecutionData>) => createQueryKey('executionsExecution', options);

/**
 * Execution
 *
 * Inspect a specific execution
 *
 * Gets the latest result if no execution_id is provided
 */
export const executionsExecutionOptions = (options: Options<ExecutionsExecutionData>) => queryOptions<ExecutionsExecutionResponse, ExecutionsExecutionError, ExecutionsExecutionResponse, ReturnType<typeof executionsExecutionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await executionsExecution({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: executionsExecutionQueryKey(options)
});

export const executionsExecutionDatasetsQueryKey = (options: Options<ExecutionsExecutionDatasetsData>) => createQueryKey('executionsExecutionDatasets', options);

/**
 * Execution Datasets
 *
 * Query the datasets that were used for a specific execution
 */
export const executionsExecutionDatasetsOptions = (options: Options<ExecutionsExecutionDatasetsData>) => queryOptions<ExecutionsExecutionDatasetsResponse, ExecutionsExecutionDatasetsError, ExecutionsExecutionDatasetsResponse, ReturnType<typeof executionsExecutionDatasetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await executionsExecutionDatasets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: executionsExecutionDatasetsQueryKey(options)
});

export const executionsExecutionLogsQueryKey = (options: Options<ExecutionsExecutionLogsData>) => createQueryKey('executionsExecutionLogs', options);

/**
 * Execution Logs
 *
 * Fetch the logs for an execution result
 */
export const executionsExecutionLogsOptions = (options: Options<ExecutionsExecutionLogsData>) => queryOptions<unknown, ExecutionsExecutionLogsError, unknown, ReturnType<typeof executionsExecutionLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await executionsExecutionLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: executionsExecutionLogsQueryKey(options)
});

export const executionsMetricBundleQueryKey = (options: Options<ExecutionsMetricBundleData>) => createQueryKey('executionsMetricBundle', options);

/**
 * Metric Bundle
 *
 * Fetch a result using the slug
 */
export const executionsMetricBundleOptions = (options: Options<ExecutionsMetricBundleData>) => queryOptions<ExecutionsMetricBundleResponse, ExecutionsMetricBundleError, ExecutionsMetricBundleResponse, ReturnType<typeof executionsMetricBundleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await executionsMetricBundle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: executionsMetricBundleQueryKey(options)
});

export const executionsListMetricValuesQueryKey = (options: Options<ExecutionsListMetricValuesData>) => createQueryKey('executionsListMetricValues', options);

/**
 * List Metric Values
 *
 * Fetch metric values for a specific execution (both scalar and series)
 *
 * - `value_type`: Type of metric values - 'scalar', 'series', or 'all' (required)
 * - `format`: Return format - 'json' (default) or 'csv'
 * - `offset`: Number of items to skip (default 0)
 * - `limit`: Maximum number of items to return (default 50, max 500)
 */
export const executionsListMetricValuesOptions = (options: Options<ExecutionsListMetricValuesData>) => queryOptions<ExecutionsListMetricValuesResponse, ExecutionsListMetricValuesError, ExecutionsListMetricValuesResponse, ReturnType<typeof executionsListMetricValuesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await executionsListMetricValues({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: executionsListMetricValuesQueryKey(options)
});

export const executionsListMetricValuesInfiniteQueryKey = (options: Options<ExecutionsListMetricValuesData>): QueryKey<Options<ExecutionsListMetricValuesData>> => createQueryKey('executionsListMetricValues', options, true);

/**
 * List Metric Values
 *
 * Fetch metric values for a specific execution (both scalar and series)
 *
 * - `value_type`: Type of metric values - 'scalar', 'series', or 'all' (required)
 * - `format`: Return format - 'json' (default) or 'csv'
 * - `offset`: Number of items to skip (default 0)
 * - `limit`: Maximum number of items to return (default 50, max 500)
 */
export const executionsListMetricValuesInfiniteOptions = (options: Options<ExecutionsListMetricValuesData>) => {
    const opts = infiniteQueryOptions<ExecutionsListMetricValuesResponse, ExecutionsListMetricValuesError, InfiniteData<ExecutionsListMetricValuesResponse>, QueryKey<Options<ExecutionsListMetricValuesData>>, number | Pick<QueryKey<Options<ExecutionsListMetricValuesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ExecutionsListMetricValuesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await executionsListMetricValues({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: executionsListMetricValuesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const executionsExecutionArchiveQueryKey = (options: Options<ExecutionsExecutionArchiveData>) => createQueryKey('executionsExecutionArchive', options);

/**
 * Execution Archive
 *
 * Stream a tar.gz archive of the execution results
 *
 * The archive is created on-the-fly and streamed directly to the client.
 */
export const executionsExecutionArchiveOptions = (options: Options<ExecutionsExecutionArchiveData>) => queryOptions<unknown, ExecutionsExecutionArchiveError, unknown, ReturnType<typeof executionsExecutionArchiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await executionsExecutionArchive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: executionsExecutionArchiveQueryKey(options)
});

export const explorerListCollectionsQueryKey = (options?: Options<ExplorerListCollectionsData>) => createQueryKey('explorerListCollections', options);

/**
 * List Collections
 */
export const explorerListCollectionsOptions = (options?: Options<ExplorerListCollectionsData>) => queryOptions<ExplorerListCollectionsResponse, DefaultError, ExplorerListCollectionsResponse, ReturnType<typeof explorerListCollectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await explorerListCollections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: explorerListCollectionsQueryKey(options)
});

export const explorerGetCollectionQueryKey = (options: Options<ExplorerGetCollectionData>) => createQueryKey('explorerGetCollection', options);

/**
 * Get Collection
 */
export const explorerGetCollectionOptions = (options: Options<ExplorerGetCollectionData>) => queryOptions<ExplorerGetCollectionResponse, ExplorerGetCollectionError, ExplorerGetCollectionResponse, ReturnType<typeof explorerGetCollectionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await explorerGetCollection({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: explorerGetCollectionQueryKey(options)
});

export const explorerListThemesQueryKey = (options?: Options<ExplorerListThemesData>) => createQueryKey('explorerListThemes', options);

/**
 * List Themes
 */
export const explorerListThemesOptions = (options?: Options<ExplorerListThemesData>) => queryOptions<ExplorerListThemesResponse, DefaultError, ExplorerListThemesResponse, ReturnType<typeof explorerListThemesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await explorerListThemes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: explorerListThemesQueryKey(options)
});

export const explorerGetThemeQueryKey = (options: Options<ExplorerGetThemeData>) => createQueryKey('explorerGetTheme', options);

/**
 * Get Theme
 */
export const explorerGetThemeOptions = (options: Options<ExplorerGetThemeData>) => queryOptions<ExplorerGetThemeResponse, ExplorerGetThemeError, ExplorerGetThemeResponse, ReturnType<typeof explorerGetThemeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await explorerGetTheme({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: explorerGetThemeQueryKey(options)
});

export const modelsListQueryKey = (options?: Options<ModelsListData>) => createQueryKey('modelsList', options);

/**
 * List
 *
 * List the models that have been run, with a tally of how their runs went.
 *
 * Counts cover the promoted version of each diagnostic, matching the rest of the app.
 */
export const modelsListOptions = (options?: Options<ModelsListData>) => queryOptions<ModelsListResponse, ModelsListError, ModelsListResponse, ReturnType<typeof modelsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await modelsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: modelsListQueryKey(options)
});

export const modelsGetQueryKey = (options: Options<ModelsGetData>) => createQueryKey('modelsGet', options);

/**
 * Get
 *
 * Summarise the runs a single model took part in, broken down by diagnostic.
 */
export const modelsGetOptions = (options: Options<ModelsGetData>) => queryOptions<ModelsGetResponse, ModelsGetError, ModelsGetResponse, ReturnType<typeof modelsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await modelsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: modelsGetQueryKey(options)
});

export const modelsEnsembleQueryKey = (options: Options<ModelsEnsembleData>) => createQueryKey('modelsEnsemble', options);

/**
 * Ensemble
 *
 * Compare this model against the ensemble, one entry per scalar metric it reported.
 *
 * Entries are ordered by how far the model sits from the ensemble mean, furthest first.
 */
export const modelsEnsembleOptions = (options: Options<ModelsEnsembleData>) => queryOptions<ModelsEnsembleResponse, ModelsEnsembleError, ModelsEnsembleResponse, ReturnType<typeof modelsEnsembleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await modelsEnsemble({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: modelsEnsembleQueryKey(options)
});

export const resultsGetResultQueryKey = (options: Options<ResultsGetResultData>) => createQueryKey('resultsGetResult', options);

/**
 * Get Result
 *
 * Fetch a result
 */
export const resultsGetResultOptions = (options: Options<ResultsGetResultData>) => queryOptions<unknown, ResultsGetResultError, unknown, ReturnType<typeof resultsGetResultQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await resultsGetResult({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: resultsGetResultQueryKey(options)
});

export const utilsHealthCheckQueryKey = (options?: Options<UtilsHealthCheckData>) => createQueryKey('utilsHealthCheck', options);

/**
 * Health Check
 */
export const utilsHealthCheckOptions = (options?: Options<UtilsHealthCheckData>) => queryOptions<UtilsHealthCheckResponse, DefaultError, UtilsHealthCheckResponse, ReturnType<typeof utilsHealthCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await utilsHealthCheck({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: utilsHealthCheckQueryKey(options)
});

export const utilsAboutQueryKey = (options?: Options<UtilsAboutData>) => createQueryKey('utilsAbout', options);

/**
 * About
 *
 * Version and freshness information about the deployment serving this API
 */
export const utilsAboutOptions = (options?: Options<UtilsAboutData>) => queryOptions<UtilsAboutResponse, DefaultError, UtilsAboutResponse, ReturnType<typeof utilsAboutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await utilsAbout({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: utilsAboutQueryKey(options)
});
